// extracted by mini-css-extract-plugin
export default {"setOutOfOffice":"SetOutOfOffice_setOutOfOffice__OkmOc"};